import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FooterService } from '../../services/footer.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
   constructor(public footerService: FooterService) {
  }
  year = new Date().getFullYear();
  async ngOnInit() {
    this.footerService.setShowFooter(true);
  }
}
